import Material from './material';

export default class MaterialGroup {
  label?: string;
  materials?: Material[];

  constructor(label: string, materials: Material[]) {
    this.label = label;
    this.materials = materials;
  }
}
